import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { topStoriesNewsRoutes } from  '../../../common/translation/translate';
import { convertUnixTimeStampToRelativeTime, parseIsoDateToDateTimeObject } from '../../../common/utilities/dateTimeUtils';

export const LifeSubStory = memo(({ subStory, enableSourceParameterOnStoriesLinks, source }) => {

    const publishedDateISO = parseIsoDateToDateTimeObject(subStory?.PublishWhen)?.toMillis();
    const relativeDateOfStory = convertUnixTimeStampToRelativeTime(publishedDateISO) ?? '';

    let subStoryHref = `${topStoriesNewsRoutes.news}${subStory?.NodeAlias}`;
    if (enableSourceParameterOnStoriesLinks) {
        subStoryHref = `${location.origin}${subStoryHref}?source=${source}`;
    }

    return (
        <Card>
            {enableSourceParameterOnStoriesLinks 
                ? <Anchor href={subStoryHref} target='_self'>
                    <Thumbnail thumbnailImageLink={subStory?.ThumbnailImageLink} />
                    <Info>
                        <Title>
                            {subStory?.Title}
                        </Title>
                        <Summary>
                            {subStory?.Summary}
                        </Summary>
                        <DaysAgo>
                            {relativeDateOfStory}
                        </DaysAgo>
                    </Info>
                </Anchor>
                :<Anchor href={subStoryHref}>
                    <Thumbnail thumbnailImageLink={subStory?.ThumbnailImageLink} />
                    <Info>
                        <Title>
                            {subStory?.Title}
                        </Title>
                        <Summary>
                            {subStory?.Summary}
                        </Summary>
                        <DaysAgo>
                            {relativeDateOfStory}
                        </DaysAgo>
                    </Info>
                </Anchor>
            }
        </Card>
    );
});

LifeSubStory.displayName = 'LifeSubStory';
LifeSubStory.propTypes = {
    subStory: PropTypes.object
};

const Card = styled.li`
    margin-top: 6px;
    padding: 5px 10px 5px 0;
    width: 50%;
    display: inline-block;
    height: 150px;

    @media ${smallMediaQuery} {
        width: 100%;
        margin: 6px 0 0 0;
        padding-right: 0;
    }
`;

const Anchor = styled.a`
    text-decoration: none;
    display: flex;
`;

const Thumbnail = styled.div`
    background-image: ${({ thumbnailImageLink }) =>
        thumbnailImageLink ? 'url(' + thumbnailImageLink + ')' : ''};
    width: 40%;
    height: 160px;
    background-color: #000000;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 2px 0 0 2px;
`;

const Info = styled.div`
    background-color: white;
    width: 60%;
    padding: 12px 16px;
    height: 160px;
    color: #455560;
    float: right;
`;

const Title = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #455560;
`;

const Summary = styled.div`
    margin: 10px 0;
    font-size: 14px;
    font-weight: 500;
    color: #7E868C;
`;

const DaysAgo = styled.div`
    margin: 10px 0;
    font-size: 11px;
    font-weight: 400;
    color: #7E868C;
`;
